import {React} from 'common'
import ButtonNavigate from 'components/Page/Login/ButtonNavigate'
import LoginBasic from 'components/Page/Login/LoginBasic'
import useLogin from 'logic/Login/useLogin'

const i18nCategory = 'login'

const Login = () => {
    const loginState = useLogin({i18nCategory})
    const {step} = loginState

    const activeI18nCategory = step === 'two_factor' ? 'two_factor' : i18nCategory

    return (
        <LoginBasic i18nCategory={activeI18nCategory} useAction={() => loginState}>
            {step === 'login' && <ButtonNavigate i18nCategory={i18nCategory} path="forgot-password" />}
        </LoginBasic>
    )
}

export default Login
